/**
 * VisuallyHidden — screen-reader-only content. Used to satisfy Radix's
 * DialogTitle accessibility requirement without visually rendering a title.
 * (Radix throws `DialogContent requires a DialogTitle` in dev otherwise.)
 */
import * as React from 'react';

export const VisuallyHidden = React.forwardRef(({ children, ...props }, ref) => (
  <span
    ref={ref}
    {...props}
    style={{
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0,
    }}
  >
    {children}
  </span>
));
VisuallyHidden.displayName = 'VisuallyHidden';
